import React, { useState, useEffect, useRef } from "react";
import { captureElementAsCanvas } from "../Utils/captureElement";
import { uploadCanvasAsImage } from "../Utils/fileUpload";
import useAuthStore from "../zustand-stores/AuthStore";
import "../css/levelUpModal.css";

const CustomLevelUpModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [levelData, setLevelData] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const levelUpCardRef = useRef(null);
  const { authSessionExists } = useAuthStore();

  useEffect(() => {
    const handleLevelUp = (event) => {
      const { newLevel, oldLevel } = event.detail;

      setLevelData({
        level: newLevel,
        image: getLevelUpImage(newLevel), // textImage: getTextImage(newLevel),
        imageNumber: newLevel < 10 ? 1 : 2,
        oldLevel,
      });
      setShowModal(true);
    };

    window.addEventListener("levelUp", handleLevelUp);
    return () => window.removeEventListener("levelUp", handleLevelUp);
  }, []);

  const getLevelUpImage = (level) => {
    const imageNumber = level < 10 ? 1 : 2;
    return `/images/level-up-images/level-up-image-${imageNumber}.png`;
  };

  const handleClose = () => {
    setShowModal(false);
    setLevelData(null);
  };

  const handleShareToChat = async () => {
    if (isUploading) return; // Prevent double clicks

    try {
      if (levelUpCardRef.current) {
        setIsUploading(true);

        const canvas = await captureElementAsCanvas(levelUpCardRef.current, {
          scale: 2,
          backgroundColor: null,
        });

        const rawImageBlob = await new Promise((resolve) => {
          canvas.toBlob(resolve, "image/png", 0.9);
        });

        // Upload the canvas image to S3
        const uploadResult = await uploadCanvasAsImage(
          canvas,
          `level-up-${levelData.level}-${Date.now()}.png`,
          "image/png",
          0.9,
        );

        handleClose();

        const shareEvent = new CustomEvent("shareLevelUp", {
          detail: {
            uploadedFile: uploadResult,
            levelData: levelData,
            rawBlobFile: rawImageBlob,
          },
        });
        window.dispatchEvent(shareEvent);
      }
    } catch (error) {
      console.error("❌ Error capturing or uploading screenshot:", error);
    } finally {
      setIsUploading(false);
    }
  };

  if (!showModal || !levelData) {
    return null;
  }

  const textShadow = `
    0 0 29px 0 rgba(0, 60, 255, 1),
    0 0 55px 0 rgba(0, 60, 255, 1),
    0 0 189px 0 rgba(0, 60, 255, 1),
    0 0 250px 0 rgba(0, 60, 255, 1),
    0 0 250px 0 rgba(0, 60, 255, 1),
    0 0 250px 0 rgba(0, 60, 255, 1)
  `;

  return (
    <>
      <div className="level-up-modal-backdrop" onClick={handleClose} />

      <div className="level-up-modal-dialog" role="dialog" aria-modal="true">
        <div className="level-up-modal-content">
          <button
            type="button"
            className="level-up-close-btn"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
          <div
            className={`level-up-image-container-${levelData.imageNumber === 1 ? "blue" : "golden"}`}
            ref={levelUpCardRef}
          >
            <img
              src={levelData.image}
              alt={`Level ${levelData.level}`}
              className="level-up-main-image"
              crossOrigin="anonymous"
              onError={(e) => {
                e.target.src = "/images/level-up-images/level-up-image-1.png";
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "88%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  margin: 0,
                  color:
                    levelData.imageNumber === 1
                      ? "rgba(214, 236, 255, 1)"
                      : "rgba(255, 253, 190, 1)",
                  fontWeight: 900,
                  fontSize: "42px", // Fix: Use fixed px instead of clamp/vw for capture stability
                  lineHeight: "1",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  fontFamily: "Poppins", // 👇 NEW: Conditional Text Shadow for the Glow Effect
                  textShadow: `
                    0 0 29px #003CFF,
      0 0 55px #003CFF,
      0 0 189px #003CFF,
      0 0 250px #003CFF,
      0 0 250px #003CFF,
      0 0 250px #003CFF
    `,
                }}
              >
                {levelData.level}
              </h1>
            </div>
          </div>

          {/* To Here */}
          <div className="d-flex gap-3 mt-4 justify-content-center level-up-action-row">
            <button
              className="btn-1 btn-1-primary px-3 text-body-b1"
              style={{ width: "182px" }}
              onClick={handleShareToChat}
              disabled={isUploading}
            >
              {isUploading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Share"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomLevelUpModal;
